import { apiRequest } from '@/utils/api';

const SENSITIVE_WORD_CATEGORY_BASE_URL = '/email-templates/api/v2/sensitive-word-categories/';
const SENSITIVE_WORD_BASE_URL = '/email-templates/api/v2/sensitive-words/';

export const sensitiveWordCategoryService = {
    // 获取敏感词分类列表
    async getCategories(params = {}) {
        try {
            const response = await apiRequest.get(SENSITIVE_WORD_CATEGORY_BASE_URL, params);
            return response.data;
        } catch (error) {
            console.error('获取敏感词分类失败:', error);
            throw error;
        }
    },

    // 获取单个敏感词分类详情
    async getCategory(id) {
        try {
            const response = await apiRequest.get(`${SENSITIVE_WORD_CATEGORY_BASE_URL}${id}/`);
            return response.data;
        } catch (error) {
            console.error(`获取敏感词分类 ${id} 失败:`, error);
            throw error;
        }
    },

    // 创建敏感词分类
    async createCategory(data) {
        try {
            const response = await apiRequest.post(SENSITIVE_WORD_CATEGORY_BASE_URL, data);
            return response.data;
        } catch (error) {
            console.error('创建敏感词分类失败:', error);
            throw error;
        }
    },

    // 更新敏感词分类
    async updateCategory(id, data) {
        try {
            const response = await apiRequest.patch(`${SENSITIVE_WORD_CATEGORY_BASE_URL}${id}/`, data);
            return response.data;
        } catch (error) {
            console.error(`更新敏感词分类 ${id} 失败:`, error);
            throw error;
        }
    },

    // 删除敏感词分类
    async deleteCategory(id) {
        try {
            const response = await apiRequest.delete(`${SENSITIVE_WORD_CATEGORY_BASE_URL}${id}/`);
            return response.data;
        } catch (error) {
            console.error(`删除敏感词分类 ${id} 失败:`, error);
            throw error;
        }
    },
};

export const sensitiveWordService = {
    // 获取敏感词列表
    async getSensitiveWords(params = {}) {
        try {
            const response = await apiRequest.get(SENSITIVE_WORD_BASE_URL, params);
            return response.data;
        } catch (error) {
            console.error('获取敏感词列表失败:', error);
            throw error;
        }
    },

    // 获取单个敏感词详情
    async getSensitiveWord(id) {
        try {
            const response = await apiRequest.get(`${SENSITIVE_WORD_BASE_URL}${id}/`);
            return response.data;
        } catch (error) {
            console.error(`获取敏感词 ${id} 失败:`, error);
            throw error;
        }
    },

    // 创建敏感词
    async createSensitiveWord(data) {
        try {
            const response = await apiRequest.post(SENSITIVE_WORD_BASE_URL, data);
            return response.data;
        } catch (error) {
            console.error('创建敏感词失败:', error);
            throw error;
        }
    },

    // 更新敏感词
    async updateSensitiveWord(id, data) {
        try {
            const response = await apiRequest.patch(`${SENSITIVE_WORD_BASE_URL}${id}/`, data);
            return response.data;
        } catch (error) {
            console.error(`更新敏感词 ${id} 失败:`, error);
            throw error;
        }
    },

    // 删除敏感词
    async deleteSensitiveWord(id) {
        try {
            const response = await apiRequest.delete(`${SENSITIVE_WORD_BASE_URL}${id}/`);
            return response.data;
        } catch (error) {
            console.error(`删除敏感词 ${id} 失败:`, error);
            throw error;
        }
    },

    // 批量操作敏感词
    async bulkOperation(data) {
        try {
            const response = await apiRequest.post(`${SENSITIVE_WORD_BASE_URL}bulk_operation/`, data);
            return response.data;
        } catch (error) {
            console.error('批量操作敏感词失败:', error);
            throw error;
        }
    },

    // 导入敏感词
    async importSensitiveWords(formData) {
        try {
            const response = await apiRequest.post(`${SENSITIVE_WORD_BASE_URL}import_words/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('导入敏感词失败:', error);
            throw error;
        }
    },

    // 导出敏感词
    async exportSensitiveWords(params = {}) {
        try {
            const response = await apiRequest.get(`${SENSITIVE_WORD_BASE_URL}export/`, {
                params,
                responseType: 'blob' // 确保接收二进制数据
            });
            // 从响应头获取文件名
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'sensitive_words.csv';
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }
            return { success: true, data: response.data, filename: filename };
        } catch (error) {
            console.error('导出敏感词失败:', error);
            throw error;
        }
    },

    // 检测文本中的敏感词
    async checkSensitiveWords(text, content_type = 'other', content_id = null) {
        try {
            const response = await apiRequest.post(`${SENSITIVE_WORD_BASE_URL}check_sensitive_words/`, {
                text,
                content_type,
                content_id
            });
            return response.data;
        } catch (error) {
            console.error('检测敏感词失败:', error);
            throw error;
        }
    },
};